const middleware = {}

middleware['gate'] = require('../middleware/gate.js')
middleware['gate'] = middleware['gate'].default || middleware['gate']

export default middleware
